var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"back-button",on:{"click":_vm.onClick}},[_c('div',{staticClass:"icon"}),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('back')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }